import { categoryDetailLinkListStyles } from "@insite/content-library/Widgets/Category/CategoryDetailLinkList";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { css } from "styled-components";

categoryDetailLinkListStyles.container = {
    gap: 0,
    css: css`
        border: rgba(3, 110, 183, 0.2) 1px solid;
        padding: 0 10px;
        max-width: 90% !important;
        ${({ theme }) => {
            return breakpointMediaQueries(
                theme,
                [
                    null,
                    css`
                        max-width: 100% !important;
                        margin-bottom: 30px;
                    `,
                    null,
                    null,
                    null,
                ],
                "max",
            );
        }}
    `,
};

categoryDetailLinkListStyles.subCategoryNameLinkItem = {
    width: 12,
    css: css`
        padding: 10px 0;
        border-bottom: rgba(3, 110, 183, 0.2) 1px solid;
        &:last-child {
            border: none;
        }
        a {
            font-weight: bold;
        }
    `,
};

categoryDetailLinkListStyles.subCategoryNameLink = {
    color: "text.main",
};
